"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.curl = void 0;
const getMethod = (m) => {
    if (!m || m === "GET") {
        return "";
    }
    return "-X POST ";
};
const getHeaders = (h, sep = "") => {
    if (!h) {
        return "";
    }
    return Object.keys(h)
        .map((k) => {
        return `-H "${k}: ${h[k]}" `;
    })
        .join(sep);
};
const getFile = (f) => {
    if (!f) {
        return "";
    }
    return `--data @${f} `;
};
exports.curl = (options, sep = "") => {
    const s = [
        getHeaders(options.headers, sep),
        getMethod(options.method),
        getFile(options.file),
        options.url,
    ].join(sep);
    return `curl ${s}`;
};
